import { Kbo } from "@models/configurators/configurator-di";
import { CToken } from "@models/configurators/ctoken";
import { KbObjectManager } from "@models/configurators/kb-object-manager";
import { UiObject } from "@models/configurators/ui-object";
import { IText } from "@models/entity-models";

@Kbo(CToken.Text)
export class Text extends UiObject implements IText {

    constructor(kom: KbObjectManager) {
        super(kom);
    }
    
    public value: string;
    public style: string;
    public color: string;
    public weight: string;
}
